import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { SharedService } from '../../../../../shared/shared.service';
import { InvoicesHD, InvoicePost } from '../invoices-main/invoice';
import { InvoiceService } from '../../invoices.service';
import { Location } from '@angular/common';
import notify from 'devextreme/ui/notify';
import { UsefulToolsService } from '../../../../../shared/other/usefultools.service';
import { MatDialog } from '@angular/material';
import { PopupTextarea } from '../../../../../shared/popups/textarea/popup-textarea';
import { TripService } from '../../../trips/trips-main/trip.services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-invoices-edit',
  templateUrl: './invoices-edit.component.html',
  styleUrls: ['./invoices-edit.component.css']
})
export class InvoicesEditComponent implements OnInit {

  dataSource: any;
  dataSource2;
  sessionId = sessionStorage.getItem('com-session-id');
  date: Date;
  invoiceID = sessionStorage.getItem('invoice-id');
  paid;

  constructor(
    private matdialog: MatDialog,
    public trip: TripService,
    public sharedService: SharedService,
    private httpClient: HttpClient,
    public datePipe: DatePipe,
    private router: Router,
    public invoice: InvoiceService,
    private location: Location,
    private usefultoolsservice: UsefulToolsService
  ) { }

  ngOnInit() {
    this.sharedService.loadingActive = true;
    if (this.invoice.invoice === 1) {
      // tslint:disable-next-line:max-line-length
      this.dataSource = {DESCRIPTION: '', INVOICEDATE: null, DUEDATE: null, INVOICETIME: null, PAID: false, RECIPIENT: '', VATNUMBER: ''};
      this.invoiceID = '-';
      this.dataSource2  = [];
      this.sharedService.loadingActive = false;
    } else {
      // tslint:disable-next-line:max-line-length
    this.httpClient.get<any>(`${this.sharedService.URL}/dbTransactionHD?SessionID=${this.sessionId}&ID=${this.invoiceID}`).subscribe(Response => {
      this.dataSource = Response.dbTransactionHD_response.view[0];
        this.date = new Date(this.dataSource.INVOICEDATE);
        this.date.setDate(this.date.getDate() + 7);
        this.dataSource.INVOICEDATE = new Date(this.dataSource.INVOICEDATE);
        this.dataSource.DUEDATE = this.date;
        if (this.dataSource.PAID !== 0) {
          this.dataSource.PAID = true;
        }  else {
          this.dataSource.PAID = false;
        }
        // tslint:disable-next-line:max-line-length
        this.httpClient.get<any>(`${this.sharedService.URL}/dbTransactionDT?SessionID=${this.sessionId}&TransactionHeaderID=${this.invoiceID}`).subscribe(Response2 => {
          this.dataSource2 = Response2.dbTransactionDT_response.view;
          console.log(this.dataSource2);
        });
    });
    this.sharedService.loadingActive = false;
    }
  }

  clickevent(data) {
    sessionStorage.setItem('trips-id', data);
    this.trip.setTrip(1);
    this.router.navigate(['/home/trips/trips-edit']);
  }


  onFormSubmit() {
    if (this.dataSource.PAID === false) {
      this.dataSource.PAID = 0;
    } else {
      this.dataSource.PAID = 1;
    }
    const postThis = {
      SessionID: sessionStorage.getItem('com-session-id'),
      TransactionHD: [this.dataSource]
    };

    if (this.invoice.invoice === 1) {
      // tslint:disable-next-line:max-line-length
      this.httpClient.post<any>(`${this.sharedService.URL}/dbTransactionHD`, postThis).subscribe(Response => {
        console.log(Response.dbTransactionHD_response.ServiceErrors[0].ERRORDESCRIPTION);
        if (Response.dbTransactionHD_response.queue[0].RESULTDESCRIPTION === 'success' && Response.dbTransactionHD_response.queue[0].RESULTACTION === 'insert') {
          this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successInsert);
          this.location.back();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbTransactionHD_response.ServiceErrors[0].ERRORDESCRIPTION}`);
        }
       });
      } else {
      this.httpClient.put<any>(`${this.sharedService.URL}/dbTransactionHD`, postThis).subscribe(Response => {
        if (Response.dbTransactionHD_response.queue[0].RESULTDESCRIPTION === 'success' && Response.dbTransactionHD_response.queue[0].RESULTACTION === 'update') {
          this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successUpdate);
          this.location.back();
        } else {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbTransactionHD_response.queue[0].ERRORDESCRIPTION}`);
        }
      });
    }
  }

  date1(data) {
    let date = data.value;
    date = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.dataSource.INVOICEDATE = date;
  }

  cancel() {
    const dialogRef = this.matdialog.open(PopupTextarea, {
      data: {
        title: 'Reason for cancellation:'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      this.dataSource['CANCELREASON'] = result;
      this.dataSource['STATUS'] = 1; // 1:Cancelled
      const sendBody = {
        SessionID: this.sessionId,
        TransactionHD: [this.dataSource]
      }

      this.httpClient.put<any>(`${this.sharedService.URL}/dbTransactionHD`, sendBody).subscribe(Response => {
        if (Response.dbTransactionHD_response.queue[0].hasOwnProperty('ERRORDESCRIPTION')) {
          this.usefultoolsservice.notify('error', `Error: ${Response.dbTransactionHD_response.queue[0].ERRORDESCRIPTION}`);
        } else {
          this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successDelete);
          this.location.back();
        }
      });
    });
  }

  printReport() {
    this.router.navigate(['/home/operations/invoices/invoices-print']);
  }


  updateRow(data)  {
    const postThis = {
      SessionID: sessionStorage.getItem('com-session-id'),
      TransactionDT:
      [
        {
          'DESCRIPTION': data.data.DESCRIPTION,
          'AMOUNT': data.data.AMOUNT,
          'TRANSACTIONHEADER_ID': this.dataSource.ID
        }
      ]
    };
    this.httpClient.post<any>(`${this.sharedService.URL}/dbTransactionDT`, postThis).subscribe(Response => {
      if (Response.dbTransactionDT_response.queue[0].RESULTDESCRIPTION === 'success' && Response.dbTransactionDT_response.queue[0].RESULTACTION === 'insert') {
        this.usefultoolsservice.notify('success', this.sharedService.notificationMessages.successUpdate);
      } else {
        this.usefultoolsservice.notify('error', `Error: ${Response.dbTransactionDT_response.queue[0].ERRORDESCRIPTION}`);
      }
    });
  }
}

